<template>
  <v-container>
    <v-form autocomplete="off">
      <div class="mb-4">
        <div class="title-container">
          <Label label="一覧に追加する会社を探す"></Label>
        </div>
        <v-simple-table class="no-border">
          <tbody>
            <tr>
              <td>
                <Label label="会社名（カナ検索可）"></Label>
              </td>
              <td>
                <InputText
                  name="name"
                  :editable="true"
                  :values="searchInputs"
                  :autofocus="autofocus"
                  placeholder="会社名"
                  @onInput="onInput"
                />
              </td>
            </tr>
            <tr>
              <td>
                <Label label="会社種別"></Label>
              </td>
              <td>
                <SelectWithFilter
                  name="company_type"
                  :editable="true"
                  :items="companyTypeArray"
                  :values="searchInputs"
                  placeholder="会社種別"
                  @onInput="onInput"
                />
              </td>
            </tr>
            <tr>
              <td>
                <Label label="法人番号"></Label>
              </td>
              <td>
                <InputText
                  name="corporate_number"
                  :editable="true"
                  class="corporate_number"
                  :values="searchInputs"
                  placeholder="法人番号"
                  validation_label="法人番号"
                  validation_rules="digit|max:13|min:13"
                  @onInput="onInput"
                />
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <div class="mr-4" style="display: flex; justify-content: flex-end">
          <v-btn color="primary" @click="onSearch"> 検索 </v-btn>
        </div>
      </div>
      <v-data-table
        v-model="selectedItems"
        :headers="SEARCH_COMPANY_TABLE_LABELS"
        :items="items"
        :items-per-page="items.length"
        :height="400"
        fixed-header
        hide-default-footer
        disable-sort
        sort-by="updatedAt"
        show-select
        noDataText="データがありません。"
        item-key="id"
        @input="onSelectionChange"
      >
        <template v-slot:[`item.company_type`]="{ item }">
          {{ handleCompanyType(item.company_type) }}
        </template>
        <template v-slot:[`item.address`]="{ item }">
          {{ handleAddress(item) }}
        </template>
      </v-data-table>
    </v-form></v-container
  >
</template>
<script>
import { Store } from "@/store/Store.js";
import { handleCompanyType } from "@/utils/common";
import {
  SEARCH_COMPANY_TABLE_LABELS,
  COMPANY_TYPE_ARR,
} from "@/constants/COMPANY";

// Components
import Label from "@/components/forms/elements/Label";
import InputText from "@/components/forms/elements/InputText";
import SelectWithFilter from "@/components/forms/elements/SelectWithFilter";

const STORE = "Company";

export default {
  components: {
    Label,
    InputText,
    SelectWithFilter,
  },
  data: () => {
    return {
      SEARCH_COMPANY_TABLE_LABELS,
      autofocus: true,
      formValues: {},
      items: [],
      selectedItems: [],
      searchInputs: {
        name: "",
        company_type: null,
        corporate_number: "",
        main_contractor_id: null,
      },
    };
  },
  props: {
    item: Object,
    formUpdate: Function,
  },
  mounted() {
    this.$watch(
      () => this.item,
      (newValue) => {
        this.formValues = { ...newValue };
      },
      {
        immediate: true,
        deep: true,
      }
    );
  },
  computed: {
    loginUser() {
      return Store.state.Login.user;
    },
    companyTypeArray() {
      let companyTypeList = [...COMPANY_TYPE_ARR];
      let companyType = [...companyTypeList.splice(1, 2)];
      companyType.unshift({
        id: null,
        name: "",
      });
      return companyType;
    },
  },
  methods: {
    async getItems() {
      this.isLoading = true;
      this.searchInputs.main_contractor_id = this.loginUser?.company_id;
      const entries = await Store.dispatch(
        `${STORE}/getCompanyToAdd`,
        this.searchInputs
      );
      if (!entries.hasError) {
        this.items = entries;
      }
      this.isLoading = false;
    },
    onSearch() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
      this.getItems();
    },
    onInput({ name, value }) {
      let searchInputs = { ...this.searchInputs };
      searchInputs[name] = value;
      this.searchInputs = searchInputs;
    },
    onSelectionChange(newVal) {
      const formValues = { ...this.formValues };
      formValues["selected_item"] = newVal;
      this.formValues = formValues;
      this.$emit("formUpdate", formValues);
    },
    handleCompanyType(type) {
      return handleCompanyType(type);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/themes.scss";

.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ::v-deep .label {
    color: black;
  }
}

.no-border {
  border: none !important;
  background-color: transparent !important;

  td {
    border: none !important;
  }

  tr:hover {
    background-color: transparent !important;
  }

  ::v-deep .label {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
}
</style>
